'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var Loader =
/*#__PURE__*/
function () {
  function Loader(instrumenter) {
    _classCallCheck(this, Loader);

    this._instrumenter = instrumenter;
  }

  _createClass(Loader, [{
    key: "reload",
    value: function reload(plugins) {
      var _this = this;

      plugins.forEach(function (meta, plugin) {
        _this._instrumenter.unload(plugin);

        _this._instrumenter.load(plugin, meta);
      });
    }
  }, {
    key: "load",
    value: function load(instrumentation, config) {
      var nodule = window[instrumentation.name];

      var override = this._instrumenter.patch(instrumentation, nodule, config);

      window[instrumentation.name] = override || nodule;
    }
  }]);

  return Loader;
}();

module.exports = Loader;